<template>
  <div class="box clearfloat">
    <div class="tab-content pubilcSty">
      <el-tabs
        tab-position="left"
        style="height: 500px; display: inline"
        @tab-click="tabclick"
        :stretch="true"
        class="tabs"
        v-model="activeName"
      >
        <el-tab-pane
          v-for="(item, i) in list"
          :key="i"
          :label="item.name"
          :name="'' + item.name"
        >
          <span slot="label">
            <i
              class="el-icon-menu"
              style="font-size: 40px; margin: 6% 30% 10% 32%"
            ></i>
            <br />
            {{ item.name }}
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="list-content pubilcSty">
      <div class="tabdownload" v-for="(item, index) in download" :key="index">
        <div
          :class="btn == index ? 'btnclick' : 'btn'"
          @click="clickdownload(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <!--<div class="pdf-content-boxs">-->
    <div class="pdf-content x2 pubilcSty" v-if="startId == '1'">
      <economize :data="data" :downLoadName="downLoadName"></economize>
    </div>
    <div class="pdf-content x3 pubilcSty" v-if="startId == '2'">
      <energycost :data="data" :downLoadName="downLoadName"></energycost>
    </div>
    <div class="pdf-content x4 pubilcSty" v-if="startId == '3'">
      <examination :data="data" :downLoadName="downLoadName"></examination>
    </div>
    <!--</div>-->
  </div>
</template>

<script>
import economize from "./bg/economize.vue";
import energycost from "./bg/energycost.vue";
import examination from "./bg/examination.vue";
export default {
  components: { economize, energycost, examination },
  inject: ["reload"],
  data() {
    return {
      activeName: "",
      download: [],
      startId: null,
      list: [],
      data: null,
      downLoadName: "",
      btn: "",
    };
  },
  created() {
    this.$api.nhtj.getReportGroups("0").then((res) => {
      this.list = res.data.filter((item) => !item.name.includes("运行分析报告"));
      if (this.list?.length) {
        this.$api.nhtj.listReport("0", [this.list[0].id]).then((res1) => {
          if (res1.data.length > 0) {
            this.activeName = this.list[0].name;
            this.download = res1.data;
            this.clickdownload(res1.data[0], 0);
          }
        });
      }
    });
  },
  mounted() {},
  methods: {
    tabclick(e) {
      this.startId = "0";
      let item = this.list.find((obj) => obj.name === e.name);
      if (this.activeName.includes("节能空间分析报告")) {
        this.$api.nhtj.listReport("0", [item.id]).then((res) => {
          // this.startId = "1";
          this.download = res.data;
          this.clickdownload(res.data[0], 0);
        });
      } else if (this.activeName.includes("用能成本分析报告")) {
        this.$api.nhtj.listReport("0", [item.id]).then((res) => {
          // this.startId = "2";
          this.download = res.data;
          this.clickdownload(res.data[0], 0);
        });
      } else if (this.activeName.includes("用能体检分析报告")) {
        this.$api.nhtj.listReport("0", [item.id]).then((res) => {
          // this.startId = "3";
          this.download = res.data;
          this.clickdownload(res.data[0], 0);
        });
      } else {
        this.data = []
      }
    },
    clickdownload(e, a) {
      this.btn = a;
      this.downLoadName = e.name;
      this.startId = "0";
      this.$api.report.peekReport(e.id).then((res) => {
        if (e.model == 2) {
          this.startId = "1";
          this.data = res.data.data;
        } else if (e.model == 3) {
          this.startId = "2";
          this.data = res.data.data;
        } else if (e.model == 4) {
          this.startId = "3";
          this.data = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
}
.pdf-content {
  margin-left: auto;
  width: calc(100% - 357px);
  position: relative;
}
.pubilcSty {
  margin: 20px 0 0 0;
}
.list-content {
  width: 216px;
  border-right: 2px solid #e4e7ed;
  margin-right: 20px;
  overflow-y: auto;
}
.pdf-content-boxs {
  width: calc(100% - 357px);
  position: relative;
}
.btnclick {
  color: #409eff;
  border-bottom: 2px solid #409eff;
  height: 40px;
}
.tabdownload {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  cursor: pointer;
}
.btn {
  cursor: pointer;
  height: 40px;
  color: #666;
}
</style>
